import React from "react";
import Icon from "components/Icon";

const IconWithBackground = ({iconName, backgroundColor, className, stroke}) => {
  return (
    <div className="inline-flex p-[10px] rounded-[6px]" style={{backgroundColor}}>
      <Icon name={iconName} className={className} stroke={stroke} />
    </div>
  )
}

export default IconWithBackground;